import SimplePeer from 'simple-peer';
import { ICON } from '../Icons/Icons';
import '../../styles/components/spacesOneOnOne.scss';

const RC_ICE = [
  { urls: 'stun:159.89.4.1:3478' },
  {
    urls: 'turn:159.89.4.1:3478',
    username: 'bagless',
    credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
  },
];

const PRODUCTION_ICE = [
  { urls: 'stun:165.227.128.104:3478' },
  {
    urls: 'turn:165.227.128.104:3478',
    username: 'bagless',
    credential: '11Vh0vvHVj6LObpjnSXyGU%K1za7N1',
  },
];

export default class SpacesOneOnOne {
  constructor({ socket, friends, config }) {
    this.socket = socket;
    this.friends = friends;
    this.config = config || {};
    this.peer = null;
    this.localStream = null;
    this.incoming = null;
    this.peerUser = null;
    this.phase = 'idle';
    this.attempt = 0;
    this.micOn = true;
    this.cameraOn = true;
    this.minimized = false;
    this.boundIo = null;
    this.audioLoops = [];

    this.mount();
    window.spacesOneOnOne = this;
    this.socket.onStatus((connected) => {
      if (connected) {
        this.bindIo();
      }
    });
    this.socket.onAnyMessage((payload) => this.onSocketMessage(payload));
    window.addEventListener('beforeunload', () => {
      const peer = this.peer;
      this.peer = null;
      this.releasePeer(peer);
      this.stopMedia();
    });
  }

  mount() {
    const fallback = '/textures/defaultAvatar.png';
    this.stage = document.createElement('div');
    this.stage.className = 'spaces-one-on-one';
    this.stage.hidden = true;
    this.stage.innerHTML = `
      <div class="spaces-one-on-one__grid">
        <div class="spaces-one-on-one__tile">
          <div class="spaces-one-on-one__media">
            <img class="spaces-one-on-one__avatar" data-avatar="local" alt="" src="${fallback}">
            <video class="spaces-one-on-one__camera" data-video="local" autoplay playsinline muted></video>
            <div class="spaces-one-on-one__audio" data-audio="local"><span></span><span></span><span></span></div>
            <div class="spaces-one-on-one__muted" data-muted="local" hidden>${ICON.MIC_OFF}</div>
          </div>
        </div>
        <div class="spaces-one-on-one__tile">
          <div class="spaces-one-on-one__media">
            <img class="spaces-one-on-one__avatar" data-avatar="remote" alt="" src="${fallback}">
            <video class="spaces-one-on-one__camera" data-video="remote" autoplay playsinline></video>
            <div class="spaces-one-on-one__audio" data-audio="remote"><span></span><span></span><span></span></div>
            <div class="spaces-one-on-one__muted" data-muted="remote" hidden>${ICON.MIC_OFF}</div>
          </div>
        </div>
      </div>
      <div class="spaces-one-on-one__bar">
        <button type="button" class="spaces-one-on-one__control" data-control="mic" aria-label="Microphone">${ICON.MIC_ON}</button>
        <button type="button" class="spaces-one-on-one__control" data-control="camera" aria-label="Camera">${ICON.CAMERA_ON}</button>
        <button type="button" class="spaces-one-on-one__control" data-control="minimize" aria-label="Minimize call">${ICON.MINIMIZE}</button>
        <button type="button" class="spaces-one-on-one__control spaces-one-on-one__control--hangup" data-control="hangup" aria-label="Hang up">${ICON.CALL_HANGUP}</button>
      </div>
    `;
    this.remoteVideo = this.stage.querySelector('[data-video="remote"]');
    this.localVideo = this.stage.querySelector('[data-video="local"]');
    this.localAvatar = this.stage.querySelector('[data-avatar="local"]');
    this.peerAvatar = this.stage.querySelector('[data-avatar="remote"]');
    this.localAudio = this.stage.querySelector('[data-audio="local"]');
    this.remoteAudio = this.stage.querySelector('[data-audio="remote"]');
    this.localMute = this.stage.querySelector('[data-muted="local"]');
    this.remoteMute = this.stage.querySelector('[data-muted="remote"]');
    this.micButton = this.stage.querySelector('[data-control="mic"]');
    this.cameraButton = this.stage.querySelector('[data-control="camera"]');
    this.minimizeButton = this.stage.querySelector('[data-control="minimize"]');
    this.localAvatar.addEventListener('error', () => { this.localAvatar.src = fallback; });
    this.peerAvatar.addEventListener('error', () => { this.peerAvatar.src = fallback; });
    this.stage.addEventListener('click', (event) => {
      const control = event.target.closest('[data-control]');
      if (!control) {
        return;
      }
      if (control.dataset.control === 'mic') {
        this.toggleMic();
      } else if (control.dataset.control === 'camera') {
        this.toggleCamera();
      } else if (control.dataset.control === 'minimize') {
        this.toggleMinimize();
      } else if (control.dataset.control === 'hangup') {
        this.hangUp();
      }
    });

    this.outgoing = this.popup('outgoing');
    this.incomingPopup = this.popup('incoming');
    document.body.append(this.stage, this.outgoing.root, this.incomingPopup.root);

    this.ring = document.createElement('audio');
    this.ring.loop = true;
    this.ring.src = '/media/call_ringtone.mp3';
  }

  popup(kind) {
    const root = document.createElement('div');
    root.className = `spaces-call-popup${kind === 'incoming' ? ' spaces-call-popup--incoming' : ' spaces-call-popup--waiting'}`;
    root.hidden = true;
    root.innerHTML = `
      <div class="spaces-call-popup__icon-wrap">
        <div class="spaces-call-popup__pulse spaces-call-popup__pulse--outer"></div>
        <div class="spaces-call-popup__pulse spaces-call-popup__pulse--middle"></div>
        <div class="spaces-call-popup__pulse spaces-call-popup__pulse--inner"></div>
        <div class="spaces-call-popup__icon">${ICON.CALL}</div>
      </div>
      <p class="spaces-call-popup__text">
        <span class="spaces-call-popup__status"></span>
        <span class="spaces-call-popup__name"></span>
      </p>
      <div class="spaces-call-popup__actions"></div>
    `;
    const actions = root.querySelector('.spaces-call-popup__actions');
    if (kind === 'outgoing') {
      actions.appendChild(this.actionButton('Cancel', 'spaces-call-popup__button--cancel', () => this.cancelOutgoing()));
    } else {
      const text = root.querySelector('.spaces-call-popup__text');
      const status = text.querySelector('.spaces-call-popup__status');
      text.appendChild(status);
      actions.appendChild(this.actionButton('Start Video Call', 'spaces-call-popup__button--accept', () => this.acceptIncoming()));
      actions.appendChild(this.actionButton('Decline', 'spaces-call-popup__button--decline', () => this.declineIncoming()));
    }
    return {
      root,
      status: root.querySelector('.spaces-call-popup__status'),
      name: root.querySelector('.spaces-call-popup__name'),
    };
  }

  actionButton(label, className, onClick) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `spaces-call-popup__button ${className}`;
    button.textContent = label;
    button.addEventListener('click', onClick);
    return button;
  }

  bindIo() {
    const io = this.socket.getIo();
    if (!io || io === this.boundIo) {
      return;
    }
    this.boundIo = io;
    io.on('callUser', (payload) => this.onIncoming(payload));
    io.on('callAccepted', (signal) => this.onAccepted(signal));
  }

  iceServers() {
    return window.location.host.indexOf('apprc') !== -1 ? RC_ICE : PRODUCTION_ICE;
  }

  myId() {
    return String(this.config.userId || '');
  }

  findOnline(predicate) {
    const users = (this.friends && this.friends.online) || this.socket.onlineUsers || [];
    return users.find(predicate) || null;
  }

  start(user) {
    if (!user || String(user.userId) === this.myId()) {
      this.flash('You can\'t call yourself.');
      return;
    }
    if (this.phase !== 'idle') {
      this.flash('You\'re already in a call.');
      return;
    }
    const io = this.socket.getIo();
    if (!io || !io.connected) {
      this.flash('Still connecting. Try again in a moment.');
      return;
    }
    const live = this.findOnline((item) => String(item.userId) === String(user.userId)) || user;
    if (live.on1on1Call) {
      this.flash('This friend is already in a call.');
      return;
    }
    const socketId = live.socketId || live.socket_id;
    if (!socketId) {
      this.flash('This friend can\'t take a call right now.');
      return;
    }

    this.peerUser = live;
    this.phase = 'calling';
    const attempt = ++this.attempt;
    this.showOutgoing(live.userName || live.username || 'Friend', 'Calling');
    this.captureMedia(attempt).then((stream) => {
      if (!stream || attempt !== this.attempt || this.phase === 'idle') {
        this.stopStream(stream);
        if (this.localStream === stream) {
          this.localStream = null;
        }
        return;
      }
      this.localStream = stream;
      this.localVideo.srcObject = stream;
      const peer = new SimplePeer({
        initiator: true,
        trickle: false,
        stream,
        config: { iceServers: this.iceServers() },
      });
      peer.on('signal', (data) => {
        io.emit('callUser', {
          userToCall: socketId,
          signalData: data,
          from: io.id,
          name: this.config.userName || '',
          userId: this.config.userId,
          userName: this.config.userName || '',
          userAvatarUrl: this.config.userAvatarUrl || '',
        });
      });
      this.bindPeer(peer, attempt);
      this.peer = peer;
    }).catch(() => {
      if (attempt === this.attempt) {
        this.finish();
        this.flash('Allow the camera and microphone to start the call.');
      }
    });
  }

  onIncoming(payload) {
    if (!payload || !payload.signal || !payload.from) {
      return;
    }
    const caller = this.callerFrom(payload);
    if (this.phase !== 'idle') {
      if (caller.userId) {
        this.sendMessage('videoOneOnOne_reject', {
          callInitiatorID: caller.userId,
          scopeId: `${caller.userId}_${this.myId()}`,
        });
      }
      return;
    }
    this.incoming = { ...payload, caller };
    this.phase = 'incoming';
    this.incomingPopup.name.textContent = caller.userName || caller.username || 'Incoming call';
    this.incomingPopup.status.textContent = (typeof $trans === 'function' && $trans('is-calling-you-text')) || 'is calling you';
    this.incomingPopup.root.hidden = false;
    this.ring.play().catch(() => {});
  }

  acceptIncoming() {
    const incoming = this.incoming;
    const io = this.socket.getIo();
    if (!incoming || !io) {
      return;
    }
    this.stopRing();
    this.incomingPopup.root.hidden = true;
    this.peerUser = incoming.caller || { userName: 'Friend' };
    this.phase = 'connecting';
    const attempt = ++this.attempt;
    this.captureMedia(attempt).then((stream) => {
      if (!stream || attempt !== this.attempt || this.phase === 'idle') {
        this.stopStream(stream);
        if (this.localStream === stream) {
          this.localStream = null;
        }
        return;
      }
      this.localStream = stream;
      this.localVideo.srcObject = stream;
      const peer = new SimplePeer({
        initiator: false,
        trickle: false,
        stream,
        config: { iceServers: this.iceServers() },
      });
      peer.on('signal', (data) => {
        io.emit('answerCall', { signal: data, to: incoming.from });
      });
      this.bindPeer(peer, attempt);
      peer.signal(incoming.signal);
      this.peer = peer;
      this.openStage();
      this.markBusy(true);
    }).catch(() => {
      if (attempt === this.attempt) {
        this.finish();
        this.flash('Allow the camera and microphone to answer the call.');
      }
    });
  }

  declineIncoming() {
    const caller = this.incoming && this.incoming.caller;
    if (caller) {
      this.sendMessage('videoOneOnOne_reject', {
        callInitiatorID: caller.userId,
        scopeId: `${caller.userId}_${this.myId()}`,
      });
    }
    this.incoming = null;
    this.phase = 'idle';
    this.incomingPopup.root.hidden = true;
    this.stopRing();
  }

  callerFrom(payload) {
    const listed = this.findOnline((item) => item.socketId === payload.from || item.socket_id === payload.from);
    if (listed) {
      return listed;
    }
    return {
      userId: payload.userId,
      userName: payload.userName || payload.name || 'Incoming call',
      userAvatarUrl: payload.userAvatarUrl || '',
      socketId: payload.from,
    };
  }

  onAccepted(signal) {
    const answer = signal && signal.sdp ? signal : signal && signal.signal;
    if (!this.peer || !answer || this.phase === 'idle') {
      return;
    }
    this.peer.signal(answer);
    this.outgoing.root.hidden = true;
    this.openStage();
    this.markBusy(true);
  }

  onSocketMessage(payload) {
    if (!payload || !payload.eventName) {
      return;
    }
    const data = payload.data || {};
    if (payload.eventName === 'videoOneOnOne_reject' && String(data.callInitiatorID) === this.myId()) {
      this.finish();
      this.flash('Call declined.');
    }
    if (payload.eventName === 'videoOneOnOne_cancel') {
      this.onRemoteHangup(data);
    }
  }

  onRemoteHangup(data) {
    const endedBy = data && data.classToBeRemoved;
    const mine = `video_notification_from_${this.myId()}`;
    if (!endedBy || endedBy === mine || this.phase === 'idle') {
      return;
    }
    const peerId = (this.peerUser && this.peerUser.userId)
      || (this.incoming && this.incoming.caller && this.incoming.caller.userId);
    if (peerId != null && endedBy !== `video_notification_from_${peerId}`) {
      return;
    }
    if (this.phase === 'incoming') {
      this.incoming = null;
      this.phase = 'idle';
      this.incomingPopup.root.hidden = true;
      this.stopRing();
      return;
    }
    this.finish();
  }

  cancelOutgoing() {
    this.notifyPeerEnded();
    this.finish();
  }

  hangUp() {
    this.notifyPeerEnded();
    this.finish();
  }

  notifyPeerEnded() {
    if (this.phase === 'idle' || this.phase === 'incoming' || !this.peerUser) {
      return;
    }
    this.sendMessage('videoOneOnOne_cancel', {
      classToBeRemoved: `video_notification_from_${this.myId()}`,
    });
  }

  bindPeer(peer, attempt) {
    peer.on('stream', (remote) => {
      if (attempt !== this.attempt || this.peer !== peer) {
        return;
      }
      this.showRemote(remote);
    });
    peer.on('close', () => {
      if (attempt !== this.attempt || this.peer !== peer) {
        return;
      }
      this.finish();
    });
    peer.on('error', () => {
      if (attempt !== this.attempt || this.peer !== peer) {
        return;
      }
      this.finish();
    });
  }

  finish() {
    if (this.finishing) {
      return;
    }
    this.finishing = true;
    const wasLive = this.phase === 'active' || this.phase === 'connecting';
    this.attempt += 1;
    const peer = this.peer;
    this.peer = null;
    try {
      this.stopAudio();
      [this.localVideo, this.remoteVideo].forEach((video) => this.detachVideo(video));
      this.releasePeer(peer);
      this.stopMedia();
      this.stage.hidden = true;
      this.stage.classList.remove('is-minimized');
      this.outgoing.root.hidden = true;
      this.incomingPopup.root.hidden = true;
      this.stopRing();
      this.phase = 'idle';
      this.incoming = null;
      this.peerUser = null;
      this.micOn = true;
      this.cameraOn = true;
      this.minimized = false;
      this.minimizeButton.innerHTML = ICON.MINIMIZE;
      this.syncTiles();
      if (wasLive) {
        this.markBusy(false);
      }
    } finally {
      this.finishing = false;
    }
  }

  openStage() {
    this.phase = 'active';
    this.setAvatars();
    this.stage.hidden = false;
    this.outgoing.root.hidden = true;
    this.syncTiles();
    this.watchAudio(this.localStream, this.localAudio);
  }

  showRemote(stream) {
    this.remoteVideo.srcObject = stream;
    this.watchRemote(stream);
    this.watchAudio(stream, this.remoteAudio);
    this.openStage();
  }

  setAvatars() {
    const fallback = '/textures/defaultAvatar.png';
    this.localAvatar.src = this.config.userAvatarUrl || fallback;
    const peer = this.peerUser || {};
    this.peerAvatar.src = peer.userAvatarUrl || peer.avatar_image_url || fallback;
  }

  syncTiles() {
    const showLocal = this.cameraOn && this.hasRealCamera();
    this.localVideo.classList.toggle('is-hidden', !showLocal);
    this.localAvatar.classList.toggle('is-hidden', showLocal);
    this.localMute.hidden = this.micOn;
    this.localAudio.hidden = !this.micOn;
    this.micButton.innerHTML = this.micOn ? ICON.MIC_ON : ICON.MIC_OFF;
    this.cameraButton.innerHTML = this.cameraOn ? ICON.CAMERA_ON : ICON.CAMERA_OFF;
  }

  hasRealCamera() {
    const track = this.localStream && this.localStream.getVideoTracks()[0];
    if (!track || track.readyState === 'ended') {
      return false;
    }
    const settings = track.getSettings ? track.getSettings() : {};
    return !!settings.deviceId;
  }

  watchRemote(stream) {
    const track = stream && stream.getVideoTracks()[0];
    const apply = () => {
      const live = !!(track && track.readyState === 'live' && track.enabled && !track.muted);
      this.remoteVideo.classList.toggle('is-hidden', !live);
      this.peerAvatar.classList.toggle('is-hidden', live);
    };
    if (!track) {
      apply();
      return;
    }
    track.addEventListener('mute', apply);
    track.addEventListener('unmute', apply);
    track.addEventListener('ended', apply);
    apply();
    const audio = stream.getAudioTracks()[0];
    const applyAudio = () => {
      const audible = !!(audio && audio.readyState === 'live' && audio.enabled && !audio.muted);
      this.remoteMute.hidden = audible;
      this.remoteAudio.hidden = !audible;
    };
    if (audio) {
      audio.addEventListener('mute', applyAudio);
      audio.addEventListener('unmute', applyAudio);
      audio.addEventListener('ended', applyAudio);
    }
    applyAudio();
  }

  showOutgoing(name, status) {
    this.outgoing.name.textContent = name;
    this.outgoing.status.textContent = status;
    this.outgoing.root.hidden = false;
  }

  flash(message) {
    this.showOutgoing('', message);
    const attempt = this.attempt;
    window.setTimeout(() => {
      if (this.phase === 'idle' && attempt === this.attempt) {
        this.outgoing.root.hidden = true;
      }
    }, 2400);
  }

  captureMedia(attempt) {
    const requests = [
      { video: true, audio: true },
      { video: true, audio: false },
      { video: false, audio: true },
    ];
    const next = (index) => {
      if (index >= requests.length) {
        if (attempt !== this.attempt) {
          return Promise.resolve(null);
        }
        return Promise.resolve(this.fallbackStream());
      }
      return navigator.mediaDevices.getUserMedia(requests[index]).then((stream) => {
        if (attempt !== this.attempt) {
          this.stopStream(stream);
          return null;
        }
        const filled = this.fillStream(stream);
        this.localStream = filled;
        return filled;
      }).catch(() => next(index + 1));
    };
    return next(0);
  }

  fillStream(stream) {
    if (!stream.getVideoTracks().length) {
      stream.addTrack(this.blankVideoTrack());
    }
    if (!stream.getAudioTracks().length) {
      stream.addTrack(this.silentAudioTrack());
    }
    return stream;
  }

  fallbackStream() {
    const stream = new MediaStream();
    stream.addTrack(this.blankVideoTrack());
    stream.addTrack(this.silentAudioTrack());
    return stream;
  }

  blankVideoTrack() {
    const canvas = document.createElement('canvas');
    canvas.width = 320;
    canvas.height = 180;
    const context = canvas.getContext('2d');
    context.fillStyle = '#11131a';
    context.fillRect(0, 0, canvas.width, canvas.height);
    const track = canvas.captureStream(10).getVideoTracks()[0];
    this.blankCanvas = canvas;
    return track;
  }

  silentAudioTrack() {
    const context = new AudioContext();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    gain.gain.value = 0;
    const destination = context.createMediaStreamDestination();
    oscillator.connect(gain);
    gain.connect(destination);
    oscillator.start();
    this.silentAudio = context;
    return destination.stream.getAudioTracks()[0];
  }

  toggleMic() {
    this.micOn = !this.micOn;
    this.setTrackEnabled('audio', this.micOn);
    this.syncTiles();
  }

  toggleCamera() {
    this.cameraOn = !this.cameraOn;
    this.setTrackEnabled('video', this.cameraOn);
    this.syncTiles();
  }

  toggleMinimize() {
    this.minimized = !this.minimized;
    this.stage.classList.toggle('is-minimized', this.minimized);
    this.minimizeButton.innerHTML = this.minimized ? ICON.EXPAND : ICON.MINIMIZE;
    this.minimizeButton.setAttribute('aria-label', this.minimized ? 'Maximize call' : 'Minimize call');
  }

  setTrackEnabled(kind, enabled) {
    if (!this.localStream) {
      return;
    }
    const tracks = kind === 'audio' ? this.localStream.getAudioTracks() : this.localStream.getVideoTracks();
    tracks.forEach((track) => {
      track.enabled = enabled;
    });
  }

  releasePeer(peer) {
    if (!peer) {
      return;
    }
    const connection = peer._pc;
    if (connection) {
      try {
        connection.getSenders().forEach((sender) => {
          this.stopTrack(sender.track);
          try {
            connection.removeTrack(sender);
          } catch (error) {
            // The sender is already gone once the connection is closing.
          }
        });
        connection.getReceivers().forEach((receiver) => this.stopTrack(receiver.track));
      } catch (error) {
        // Closing below still drops the capture.
      }
      try {
        connection.close();
      } catch (error) {
        // Already closed.
      }
    }
    try {
      peer.removeAllListeners();
      if (!peer.destroyed && !peer.destroying) {
        peer.destroy();
      }
    } catch (error) {
      // The local capture is released even if the peer object is already dead.
    }
  }

  stopMedia() {
    this.stopAudio();
    [this.localVideo, this.remoteVideo].forEach((video) => this.detachVideo(video));
    this.stopStream(this.localStream);
    this.localStream = null;
    this.blankCanvas = null;
    if (this.silentAudio && this.silentAudio.state !== 'closed') {
      this.silentAudio.close();
    }
    this.silentAudio = null;
  }

  detachVideo(video) {
    if (!video) {
      return;
    }
    try {
      video.pause();
    } catch (error) {
      // The element can already be paused.
    }
    video.srcObject = null;
    try {
      video.load();
    } catch (error) {
      // Detaching srcObject is enough when load() is unavailable.
    }
  }

  stopStream(stream) {
    if (!stream || typeof stream.getTracks !== 'function') {
      return;
    }
    stream.getTracks().forEach((track) => this.stopTrack(track));
  }

  stopTrack(track) {
    if (!track || track.readyState === 'ended') {
      return;
    }
    try {
      track.stop();
    } catch (error) {
      // The device is already released.
    }
  }

  watchAudio(stream, indicator) {
    this.stopAudio(indicator);
    if (!stream || !indicator || !stream.getAudioTracks().some((track) => track.readyState === 'live')) {
      return;
    }
    try {
      const context = new AudioContext();
      const source = context.createMediaStreamSource(stream);
      const analyser = context.createAnalyser();
      analyser.fftSize = 256;
      source.connect(analyser);
      const data = new Uint8Array(analyser.frequencyBinCount);
      const loop = { context, source, indicator, frame: 0 };
      const tick = () => {
        analyser.getByteFrequencyData(data);
        let sum = 0;
        for (let i = 0; i < data.length; i += 1) {
          sum += data[i];
        }
        indicator.classList.toggle('is-active', sum / data.length > 12);
        loop.frame = window.requestAnimationFrame(tick);
      };
      this.audioLoops.push(loop);
      tick();
    } catch (error) {
      // The call still works if the browser blocks the audio meter.
    }
  }

  stopAudio(indicator) {
    const kept = [];
    this.audioLoops.forEach((loop) => {
      if (indicator && loop.indicator !== indicator) {
        kept.push(loop);
        return;
      }
      window.cancelAnimationFrame(loop.frame);
      loop.indicator.classList.remove('is-active');
      if (loop.source) {
        loop.source.disconnect();
      }
      if (loop.context && loop.context.state !== 'closed') {
        loop.context.close();
      }
    });
    this.audioLoops = kept;
  }

  stopRing() {
    this.ring.pause();
    this.ring.currentTime = 0;
  }

  markBusy(busy) {
    this.sendMessage('userVideoStateChanged', {
      userVideoOn: false,
      on1on1Call: busy,
    });
  }

  sendMessage(eventName, data) {
    this.socket.send({
      eventName,
      senderId: this.config.userId,
      data,
    });
  }
}
